import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const API_URL = "/api/instructor/";

export const videoApi = createApi({
  reducerPath: "video",
  baseQuery: fetchBaseQuery({ baseUrl: API_URL }),
  endpoints: (builder) => ({
    // Get video by batch
    getVideo: builder.query({
      query: ({ batch, batchModule, Token }) => ({
        url: `/video/${batch}/${batchModule}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      }),
      providesTags: ["Students", "Student"],
      invalidatesTags: ["Students", "Student", "Fee"],
    }),

    getInstructorVideos: builder.query({
      query: ({ batch, batchModule, Token }) => ({
        url: `/videos/${batch}/${batchModule}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      }),
      providesTags: ["InstructorVideos"],
    }),

    // Add new video to batch
    addVideo: builder.mutation({
      query: ({ title, url, batch, batchModule, token }) => ({
        url: `/video`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: { title, url, batchModule, batch },
      }),
      invalidatesTags: ["Videos", "Students", "Student", "InstructorVideos"],
    }),

    // Update video details
    updateVideo: builder.mutation({
      query: ({ videoId, videoData, token }) => ({
        url: `/video/${videoId}`,
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: videoData, // Video data to update
      }),
      invalidatesTags: ["Students", "Student"],
    }),

    // Delete a video
    deleteVideo: builder.mutation({
      query: ({ videoId, token }) => ({
        url: `/video/${videoId}`,
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
      invalidatesTags: ["Students", "Student", "InstructorVideos"],
    }),

    // Get all students for a batch (example)
    getAllStudents: builder.query({
      query: (batch) => ({
        url: `/students/${batch}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      }),
      providesTags: ["Students"],
      invalidatesTags: ["Student"],
    }),

    // Get details of a student (example)
    getStudentDetails: builder.query({
      query: (studentId) => ({
        url: `/student/${studentId}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      }),
      providesTags: ["Student"],
    }),
  }),
});

export const {
  useGetInstructorVideosQuery,
  useGetVideoQuery,
  useAddVideoMutation,
  useDeleteVideoMutation,
  useGetAllStudentsQuery,
  useGetStudentDetailsQuery,
  useUploadContentMutation,
} = videoApi;
